// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 17) return "static/js/1ef0f7a430dc990d5342.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"773c00cd5870c315d559","122":"ca07b78f85eb9a0f7b7a","123":"6fa28ebd0c622e07bb3d"}[chunkId] + ".chunk.js";
};